import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 2rem;
  padding-top: 0px;
`;

export const IconWrapper = styled.div`
  width: 100px;

  svg {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const Banner = styled.div`
  background-color: white;
  border-radius: 4px;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LoadingIconWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const Description = styled.div`
  margin-left: 20px;
  margin-top: 20px;
  width: 90%;
  padding-right: 10px;
`;

export const Title = styled.h5`
  font-size: 16px;
  font-weight: bold;
`;

export const ButtonWrapper = styled.div``;
